/**
 * Helpers for creating Roles instance
 */

import type { IBaseAdmin } from "../../BaseAdminFactory";
import type { Role } from "le-coffre-resources/dist/Admin";
import type { QueryPayload } from "../../../../types";
import type { IGetRolesParams, IPutRoleParams, IPostRoleParams } from "../Roles";
import {
	createGetMethod,
	createPostMethod,
	createGetOneMethod,
	createGetByUidMethod,
	createPutMethod,
} from "./rolesMethodsHelpers";

export interface RolesInstance {
	get(q?: IGetRolesParams): Promise<Role[]>;
	post(body: IPostRoleParams): Promise<Role>;
	getOne(q?: IGetRolesParams): Promise<Role | null>;
	getByUid(uid: string, q?: QueryPayload): Promise<Role>;
	put(uid: string, body: IPutRoleParams): Promise<Role>;
}

/**
 * Create Roles instance with all methods
 */
export function createRolesInstance(baseAdmin: IBaseAdmin): RolesInstance {
	const baseUrl = baseAdmin.namespaceUrl.concat("/roles");

	return {
		get: createGetMethod(baseAdmin, baseUrl),
		post: createPostMethod(baseAdmin, baseUrl),
		getOne: createGetOneMethod(baseAdmin, baseUrl),
		getByUid: createGetByUidMethod(baseAdmin, baseUrl),
		put: createPutMethod(baseAdmin, baseUrl),
	};
}
